import React from 'react';
import './Refund.scss';

const RefundPolicy = () => {
  return (
    <div className="refund-policy">
      <h1>Refund Policy</h1>

      <p>
        At Divya Jyotisa, we strive to ensure your satisfaction with our spiritual consultations, products, and services. However, due to the personalized and unique nature of our offerings, we have the following refund policy:
      </p>

      <section>
        <h2>Consultations and Readings</h2>
        <p>
          All astrological consultations, tarot readings, and other spiritual services are <strong>non-refundable</strong> once the session has taken place. These services are based on personalized insights and guidance, tailored specifically to your needs.
        </p>
        <p>
          If you are unable to attend your scheduled session, you may reschedule it with at least <strong>24 hours’ notice</strong>. Failure to provide sufficient notice may result in forfeiture of the session fee.
        </p>
      </section>

      <section>
        <h2>Products (Oils, Bath Salts, Gemstones, etc.)</h2>
        <h3>Physical Products:</h3>
        <p>
          Refunds or exchanges may be offered only if the product is defective or damaged upon receipt. Please notify us within <strong>7 days</strong> of receiving the item with a photograph of the damage or defect. Return shipping costs are the responsibility of the customer, unless the item was received in a defective condition.
        </p>

        <h3>Digital Products:</h3>
        <p>
          No refunds are provided for downloadable products such as e-books, courses, or reports. <strong>All sales are final.</strong>
        </p>
      </section>

      <section>
        <h2>Workshops and Courses</h2>
        <p>
          Refunds for workshops, classes, or courses are available if requested at least <strong>48 hours</strong> before the event or course start date. Once the event has commenced, no refunds will be issued.
        </p>
      </section>

      <section>
        <h2>Special Circumstances</h2>
        <p>
          We understand that situations may arise where you feel a refund is warranted. In such cases, we encourage you to reach out to us at <a href="mailto:destinyastha@gmail.com">destinyastha@gmail.com</a> to discuss the issue. Refunds, if granted, will be at the discretion of Divya Jyotisa.
        </p>
      </section>

      <section>
        <h2>How to Request a Refund</h2>
        <p>
          To request a refund or report a damaged product, please email us at <a href="mailto:destinyastha@gmail.com">destinyastha@gmail.com</a> with your order number and details. We aim to process refund requests within <strong>7-10 business days.</strong>
        </p>
      </section>
    </div>
  );
};

export default RefundPolicy;
